export class EventEmitter {
    constructor() {
        this.listeners = {};
    }
    on(eventName, fn) {
        if (!this.listeners[eventName]) {
            this.listeners[eventName] = [];
        }
        this.listeners[eventName].push(fn);
    }
    off(eventName, fn) {
        if (!this.listeners[eventName]) {
            return;
        }
        this.listeners[eventName] = this.listeners[eventName].filter(listener => listener !== fn);
    }
    emit(eventName, ...args) {
        if (!this.listeners[eventName]) {
            return;
        }
        this.listeners[eventName].forEach(listener => {
            listener.apply(this, args);
        });
    }
    getListenerCount(eventName) {
        var _a;
        return (_a = this.listeners[eventName]) !== null && _a !== void 0 ? _a : 0;
    }
}
